import React from "react"
import { useTranslation } from "react-i18next"

import { Select } from "components"

const paymentTypeOptions = [
  { value: "zarinpal", label: "زرینپال" },
  { value: "pna", label: "پرداخت نوین" },
  { value: "bpMellat", label: "به پرداخت" },
  { value: "sadad", label: "سداد" },
  { value: "wallet", label: "کیف پول" },
  { value: "cash", label: "نقدی" },
  { value: "cod", label: "پرداخت موقع تحویل" }
]

const PaymentSelectFilter = props => {
  const {
    className,
    onChange,
    value,
    isMulti,
    isClearable
  } = props

  const [t] = useTranslation()

  return (
    <Select
      isClearable={isClearable}
      isMulti={isMulti}
      isSearchable={false}
      noOptionsMessage={() => null}
      label={t("روش_پرداخت")}
      placeholder={t("روش_پرداخت_را_وارد_کنید")}
      options={paymentTypeOptions}
      className={className}
      onChange={onChange}
      value={value}
    />
  )
}

export default PaymentSelectFilter